import { V } from "../misc/Vector.js";
export { Orbit };
class Orbit {
    constructor({ waypoint, center, radius, width, spacing }) {
        this.waypoint = waypoint;
        this.center = center;
        this.radius = radius;
        this.width = width;
        this.widthHalf = 0.5 * width;
        this.spacing = spacing;
    }
    clone() {
        return new Orbit({
            waypoint: this.waypoint,
            center: this.center,
            radius: this.radius,
            width: this.width,
            spacing: this.spacing
        });
    }
    get innerSpacing() {
        return this.innerWidth - this.spacing;
    }
    get outerSpacing() {
        return this.outerWidth + this.spacing;
    }
    get innerWidth() {
        return this.radius - this.widthHalf;
    }
    get outerWidth() {
        return this.radius + this.widthHalf;
    }
    isOnOrbit({ point, direction }) {
        const vector = V.subtract(this.center, point);
        const distance = V.norm(vector);
        const dot = Math.abs(V.dot(vector, direction));
        return Math.abs(dot) < 1e-6 && Math.abs(distance - this.radius) < 1e-6;
    }
    nextRadius({ width, spacing, minBendradius }) {
        const widthHalf = 0.5 * width;
        const offset = this.widthHalf + widthHalf + (this.spacing > spacing ? this.spacing : spacing);
        const computedRadius = this.radius + offset;
        return minBendradius > computedRadius ? minBendradius : computedRadius;
    }
    static of({ previousOrbit, width, spacing, minBendradius }) {
        const radius = previousOrbit.nextRadius({ width, spacing, minBendradius });
        return new Orbit({
            waypoint: previousOrbit.waypoint,
            center: previousOrbit.center,
            radius,
            width,
            spacing
        });
    }
    static zeroOrbit({ waypoint, center, spacing }) {
        return new Orbit({
            waypoint,
            center,
            radius: 0,
            width: 0,
            spacing
        });
    }
}
//# sourceMappingURL=Orbit.js.map